
import {
    defineComponent,
    onMounted,
    ref,
    toRef,
    watch,
    onBeforeMount,
    inject,
    onUpdated,
    onBeforeUpdate
} from "vue";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import {
    TweenMax
} from "gsap";
import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";
import {
    ModeFormMenuExpand,
    Menu
} from "@/components/cigo-admin-core/utils/types";
import {
    showPage
} from "../utils/common";

export default defineComponent({
    name: "MenuList",
    components: {
        CigoIconFont
    },
    props: {
        menuList: {
            type: Array as() => Menu[],
            require: true,
            default: []
        },
        level: {
            type: Number,
            default: 0
        }
    },
    setup(props) {
        let menuTreeListRef: any = inject("menuTreeListRef"); //Tips_FLAG 父变子变示例1/3：provide & inject
        onBeforeMount(() => {
            if (props.level == 0) {
                watch(menuTreeListRef, (newVal, preVal) => {
                    //TODO 刷新数据导致当前路由应该展开root菜单未展开
                    // 须重新梳理菜单展开及相关逻辑
                    if (!menuOpenFlag.value && expandMenuItem.value.id) {
                        recordClickMenu(expandMenuItem.value, false); // 清空当前菜单
                    }
                });
            }
        });
        let currComponent = toRef(
            CigoAdminStore.getState().systemState,
            "currComponent"
        );
        let menuItemExpand: Menu = {
            id: 0,
            title: ""
        };
        let expandMenuItem = ref(menuItemExpand);
        let menuOpenFlag = toRef(
            CigoAdminStore.getState().systemState,
            "sideMenuOpen"
        );
        let titleGoneFlag = ref(false);
        let menuBaseListNameMapRef: any = inject("menuBaseListNameMapRef");

        onMounted(() => {
            menuChange(menuOpenFlag.value);
        });

        watch(menuOpenFlag, (openFlag: boolean, preOpenFLag: boolean) => {
            menuChange(openFlag);
        });

        /** 监听菜单变化 */
        const menuChange = (openFlag: boolean) => {
            TweenMax.to(
                ".first-level>.menu-item>.item-right>.item-title",
                0.8, {
                    opacity: openFlag ? 1 : 0,
                    delay: 0
                }
            );
            TweenMax.to(".first-level>.menu-group", 0.8, {
                height: openFlag ? "35px" : "0px",
                opacity: openFlag ? 1 : 0,
                delay: 0,
                onStart: () => {
                    if (openFlag) {
                        titleGoneFlag.value = false;
                    }
                },
                onComplete: () => {
                    if (!openFlag) {
                        titleGoneFlag.value = true;
                    }
                }
            });
            //如果左侧菜单为关闭状态，则闭合当前正展开的一级菜单
            if (!openFlag && expandMenuItem.value.id) {
                recordClickMenu(expandMenuItem.value, false); // 清空当前菜单
            }
        };

        /** 获取菜单项容器Class */
        const makeMenuItemContainerClass = (item: Menu) => {
            let classes: string[] = [];
            classes.push(menuOpenFlag.value ? "menu-open" : "menu-close");
            classes.push(item.level == 0 ? "first-level" : "");

            //左侧栏开启状态：则处理一级菜单展开问题
            if (menuOpenFlag.value && !item.group_flag && item.level == 0) {
                let flag: string = "close";
                //分析是否展开
                switch (CigoAdminStore.getState().noCached.modeForMenuExpand) {
                    case ModeFormMenuExpand.CLICK_MENU: //点击菜单为主
                        flag = modeForMenuExpandClickMenu(item);
                        break;
                    case ModeFormMenuExpand.NOW_ROUTER: //跳转路由为主
                        flag = modeForMenuExpandNowRouter(item);
                        break;
                    default:
                        //未知
                        break;
                }
                classes.push(flag);
            }
            return classes;
        };

        /** 点击菜单为主：处理 */
        const modeForMenuExpandClickMenu = (item: Menu) => {
            let flag = "close";
            if (item.subList && item.subList.length > 0) {
                flag = expandMenuItem.value.id == item.id ? "expand" : "close";
            }
            return flag;
        };
        /** 跳转路由为主：处理 */
        const modeForMenuExpandNowRouter = (item: Menu): string => {
            if (
                !menuBaseListNameMapRef.value ||
                !menuBaseListNameMapRef.value.has(currComponent.value)
            ) {
                return "close";
            }
            let routerItem: Menu = menuBaseListNameMapRef.value.get(
                currComponent.value
            );

            // 能跳转当前路由说明没有子项，返回关闭，且清空当前展开菜单项记录，以触发正打开项目
            if (item.component_name == currComponent.value) {
                expandMenuItem.value = {
                    id: 0,
                    title: ""
                };
                return "close";
            }
            // 非当前菜单，则检查是否当前路由项级联菜单root级菜单
            // 是则置为展开，否则关闭
            else if (
                routerItem &&
                routerItem.path &&
                item.path &&
                routerItem.path.indexOf(item.path + item.id + ",") >= 0
            ) {
                // 1:当前展开root级菜单不触发切换，避免出现点击二级展开导致菜单关闭的问题
                if (item.id != expandMenuItem.value.id) {
                    expandMenuItem.value = item;
                }
                // 2:但保留展开状态
                return "expand";
            }
            return "close";
        };

        /** 获取菜单项Class */
        const makeMenuItemClass = (item: Menu) => {
            let classes: string[] = [];
            if (!item.group_flag) {
                classes.push("menu-item");

                //标记当前(根据菜单项级联路径，保证当前级联菜单项的所有父辈都能够高亮)
                if (
                    menuBaseListNameMapRef.value &&
                    menuBaseListNameMapRef.value.has(currComponent.value)
                ) {
                    let nowItem: Menu = menuBaseListNameMapRef.value.get(
                        currComponent.value
                    );
                    if (item.id == nowItem.id) {
                        classes.push("curr");
                    } else if (
                        nowItem &&
                        nowItem.path &&
                        item.path &&
                        nowItem.path.indexOf(item.path + item.id + ",") >= 0
                    ) {
                        classes.push("curr");
                    }
                }
            } else {
                classes.push("menu-group");
                if (item.level == 0 && titleGoneFlag.value) {
                    classes.push("gone");
                }
            }
            return classes;
        };

        /** 点击菜单项事件处理 */
        const clickMenu = (item: Menu) => {
            // 分组项无动作
            if (item.group_flag) {
                return;
            }

            // 一级菜单&左边栏开启状态下记录点击菜单项
            if (item.level == 0 && menuOpenFlag.value) {
                //记录有效点击菜单
                recordClickMenu(item, true);
            }

            // 无子菜单直接跳转
            if (!item.subList || item.subList.length == 0) {
                showPage(item);
            }
        };

        /** 记录点击菜单项 */
        const recordClickMenu = (item: Menu, changeMode: boolean) => {
            // 记录点击菜单项
            expandMenuItem.value =
                item.id == expandMenuItem.value.id ? {
                    id: 0,
                    title: ""
                } :
                item;

            if (changeMode) {
                CigoAdminStore.setModeForMenuExpand(ModeFormMenuExpand.CLICK_MENU); //修改菜单展开模式为点击展开模式
            }
        };

        /** 鼠标滑入/滑出菜单项 */
        const hoverMenuItem = (item: Menu, inOutFlag: boolean) => {
            if (item.level == 0 && menuOpenFlag.value) {
                return;
            }
            subMenuListAnimation(item, inOutFlag);
        };
        watch(expandMenuItem, (newMenu: Menu, preMenu: Menu) => {
            subMenuListAnimation(newMenu, true);
            if (
                CigoAdminStore.getState().noCached.modeForMenuExpand ==
                ModeFormMenuExpand.CLICK_MENU ||
                newMenu.id != preMenu.id
            ) {
                subMenuListAnimation(preMenu, false);
            }
        });
        //TODO v-for中refs的应用
        let vMenuListTmp: any[] = [];
        const vMenuListRefs = ref(vMenuListTmp);
        onBeforeUpdate(() => {
            vMenuListRefs.value = [];
        })
        //TODO 优化菜单管理，level的使用：是用item.level还是props.level
        const subMenuListAnimation = (item: Menu, openFlag: boolean) => {
            if (!item.subList || !item.subList.length) {
                return;
            }
            let subListHeight = item.subList.length * 40 + "px";
            let animOptions = {};
            if (menuOpenFlag.value && props.level == 0) {
                TweenMax.to("#sub-list-" + item.id, 0.5, {
                    height: openFlag ? subListHeight : "0px",
                    opacity: openFlag ? 1 : 0,
                    display: openFlag ? "flex" : "none"
                });

                TweenMax.to(
                    "#sub-list-" + item.id + ">.menu-container>.menu-common",
                    0.5, {
                        height: openFlag ? "40px" : "0px",
                        opacity: openFlag ? 1 : 0
                    }
                );
                updateLeftMenuListWidth(openFlag);
            } else {
                TweenMax.to("#sub-list-" + item.id, 0.5, {
                    width: openFlag ? "240px" : "0px",
                    height: openFlag ? subListHeight : "0px",
                    opacity: openFlag ? 1 : 0,
                    display: openFlag ? "flex" : "none"
                });

                TweenMax.to(
                    "#sub-list-" + item.id + ">.menu-container>.menu-common",
                    0.5, {
                        width: openFlag ? "240px" : "0px",
                        height: openFlag ? "40px" : "0px",
                        opacity: openFlag ? 1 : 0
                    }
                );
                updateLeftMenuListWidth(openFlag);
            }
        };

        const updateLeftMenuListWidth = (openFLag: boolean) => {
            let newWidth = menuOpenFlag.value ? 250 : 113;
            let num = 0;
            if (menuOpenFlag.value) {
                num = openFLag ? props.level : props.level - 1;
            } else {
                num = openFLag ? props.level + 1 : props.level;
            }
            num = num > 0 ? num : 0;
            newWidth += num * 240;

            CigoAdminStore.setLeftMenuContainerWidth(newWidth + "px");
        };

        return {
            vMenuListRefs,
            makeMenuItemContainerClass,
            makeMenuItemClass,
            clickMenu,
            hoverMenuItem,
            titleGoneFlag,
            currComponent
        };
    }
});
